module.exports = __webpack_public_path__ + "img/icon-warning.c24871ea.svg";